import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { BettingLimit, BettingLimitParams, TimedBettingLimitParams, WageringLimitParams } from "./betting-limit.model";

const ACTION_PREFIX = "[Betting Limit]";
const ACTION_PREFIX_BETTING_LIMIT = "[BetCount Limit]";
const ACTION_PREFIX_BETTING_SIZE_LIMIT = "[BetSize Limit]";
const ACTION_PREFIX_WAGERING_LIMIT = "[Wagering Limit]";
const ACTION_PREFIX_TIMED_WAGERING_LIMIT = "[Timed Wagering Limit]";
const ACTION_PREFIX_NETLOSS_LIMIT = "[Netloss Limit]";

export const BETTING_LIMIT_ACTION_TYPE = {
	getBetCountLimit: `${ACTION_PREFIX_BETTING_LIMIT} Get BetCount Limit`,
	getBetCountLimitSuccess: `${ACTION_PREFIX_BETTING_LIMIT} Get BetCount Limit Success`,
	getBetCountLimitFail: `${ACTION_PREFIX_BETTING_LIMIT} Get BetCount Limit Fail`,

	getBetSizeLimit: `${ACTION_PREFIX_BETTING_LIMIT} Get BetSize Limit`,
	getBetSizeLimitSuccess: `${ACTION_PREFIX_BETTING_LIMIT} Get BetSize Limit Success`,
	getBetSizeLimitFail: `${ACTION_PREFIX_BETTING_LIMIT} Get BetSize Limit Fail`,

	getWageringLimit: `${ACTION_PREFIX_WAGERING_LIMIT} Get Wagering Limit`,
	getWageringLimitSuccess: `${ACTION_PREFIX_WAGERING_LIMIT} Get Wagering Limit Success`,
	getWageringLimitFail: `${ACTION_PREFIX_WAGERING_LIMIT} Get Wagering Limit Fail`,

	getTimedWageringLimit: `${ACTION_PREFIX_TIMED_WAGERING_LIMIT} Get Timed Wagering Limit`,
	getTimedWageringLimitSuccess: `${ACTION_PREFIX_TIMED_WAGERING_LIMIT} Get Timed Wagering Limit Success`,
	getTimedWageringLimitFail: `${ACTION_PREFIX_TIMED_WAGERING_LIMIT} Get Timed Wagering Limit Fail`,

	getRemainingBetLimit: `${ACTION_PREFIX_TIMED_WAGERING_LIMIT} Get Remaining Bet Limit`,
	getRemainingBetLimitSuccess: `${ACTION_PREFIX_TIMED_WAGERING_LIMIT} Get Remaining Bet Limit Success`,
	getRemainingBetLimitFail: `${ACTION_PREFIX_TIMED_WAGERING_LIMIT} Get Remaining Bet Limit Fail`,

	getNetlossLimit: `${ACTION_PREFIX_NETLOSS_LIMIT} Get Netloss Limit`,
	getNetlossLimitSuccess: `${ACTION_PREFIX_NETLOSS_LIMIT} Get Netlosss Limit Success`,
	getNetlossLimitFail: `${ACTION_PREFIX_NETLOSS_LIMIT} Get Netloss Limit Fail`,

	updateBetCountLimit: `${ACTION_PREFIX_BETTING_LIMIT} Update BetCount Limit`,
	updateBetCountLimitSuccess: `${ACTION_PREFIX_BETTING_LIMIT} Update BetCount Limit Success`,
	updateBetCountLimitFail: `${ACTION_PREFIX_BETTING_LIMIT} Update BetCount Limit Fail`,

	updateBetSizeLimit: `${ACTION_PREFIX_BETTING_SIZE_LIMIT} Update BetSize Limit`,
	updateBetSizeLimitSuccess: `${ACTION_PREFIX_BETTING_SIZE_LIMIT} Update BetSize Limit Success`,
	updateBetSizeLimitFail: `${ACTION_PREFIX_BETTING_SIZE_LIMIT} Update BetSize Limit Fail`,

	updateWageringLimit: `${ACTION_PREFIX_WAGERING_LIMIT} Update Wagering Limit`,
	updateWageringLimitSuccess: `${ACTION_PREFIX_WAGERING_LIMIT} Update Wagering Limit Success`,
	updateWageringLimitFail: `${ACTION_PREFIX_WAGERING_LIMIT} Update Wagering Limit Fail`,

	updateTimedWageringLimit: `${ACTION_PREFIX_TIMED_WAGERING_LIMIT} Update Timed Wagering Limit`,
	updateTimedWageringLimitSuccess: `${ACTION_PREFIX_TIMED_WAGERING_LIMIT} Update Timed Wagering Limit Success`,
	updateTimedWageringLimitFail: `${ACTION_PREFIX_TIMED_WAGERING_LIMIT} Update Timed Wagering Limit Fail`,

	updateNetlossLimit: `${ACTION_PREFIX_NETLOSS_LIMIT} Update Netloss Limit`,
	updateNetlossLimitSuccess: `${ACTION_PREFIX_NETLOSS_LIMIT} Update Netloss Limit Success`,
	updateNetlossLimitFail: `${ACTION_PREFIX_NETLOSS_LIMIT} Update Netloss Limit Fail`,

	removeBetCountLimit: `${ACTION_PREFIX_BETTING_LIMIT} Remove BetCount Limit`,
	removeBetCountLimitSuccess: `${ACTION_PREFIX_BETTING_LIMIT} Remove BetCount Limit Success`,
	removeBetCountLimitFail: `${ACTION_PREFIX_BETTING_LIMIT} Remove BetCount Limit Fail`,

	removeBetSizeLimit: `${ACTION_PREFIX_BETTING_SIZE_LIMIT} Remove BetCount Limit`,
	removeBetSizeLimitSuccess: `${ACTION_PREFIX_BETTING_SIZE_LIMIT} Remove BetCount Limit Success`,
	removeBetSizeLimitFail: `${ACTION_PREFIX_BETTING_SIZE_LIMIT} Remove BetCount Limit Fail`,

	removeWageringLimit: `${ACTION_PREFIX_BETTING_LIMIT} Remove Wagering Limit`,
	removeWageringLimitSuccess: `${ACTION_PREFIX_BETTING_LIMIT} Remove Wagering Limit Success`,
	removeWageringLimitFail: `${ACTION_PREFIX_BETTING_LIMIT} Remove Wagering Limit Fail`,

	removeTimedWageringLimit: `${ACTION_PREFIX_BETTING_LIMIT} Remove Timed Wagering Limit`,
	removeTimedWageringLimitSuccess: `${ACTION_PREFIX_BETTING_LIMIT} Remove Timed Wagering Limit Success`,
	removeTimedWageringLimitFail: `${ACTION_PREFIX_BETTING_LIMIT} Remove Timed Wagering Limit Fail`,

	removeTimedWageringLimitWithPayload: `${ACTION_PREFIX_BETTING_LIMIT} Remove Timed Wagering Limit With Payload`,
	removeTimedWageringLimitWithPayloadSuccess: `${ACTION_PREFIX_BETTING_LIMIT} Remove Timed Wagering Limit With Payload Success`,
	removeTimedWageringLimitWithPayloadFail: `${ACTION_PREFIX_BETTING_LIMIT} Remove Timed Wagering Limit With Payload Fail`,

	removeNetlossLimit: `${ACTION_PREFIX_NETLOSS_LIMIT} Remove Netloss Limit`,
	removeNetlossLimitSuccess: `${ACTION_PREFIX_NETLOSS_LIMIT} Remove Netloss Limit Success`,
	removeNetlossLimitFail: `${ACTION_PREFIX_NETLOSS_LIMIT} Remove Netloss Limit Fail`,

	removeNetlossLimitWithPayload: `${ACTION_PREFIX_NETLOSS_LIMIT} Remove Netloss Limit With Payload`,
	removeNetlossLimitWithPayloadSuccess: `${ACTION_PREFIX_NETLOSS_LIMIT} Remove Netloss Limit With Payload Success`,
	removeNetlossLimitWithPayloadFail: `${ACTION_PREFIX_NETLOSS_LIMIT} Remove Netloss Limit With Payload Fail`,

	reset: `${ACTION_PREFIX} Clear`,
};

export namespace BettingLimitAction {
	export const getBetCountLimit = (): Action => ({
		type: BETTING_LIMIT_ACTION_TYPE.getBetCountLimit,
	});

	export const getBetCountLimitSuccess = (payload: BettingLimit[]): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getBetCountLimitSuccess,
		payload,
	});

	export const getBetCountLimitFail = (payload: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getBetCountLimitFail,
		payload,
	});

	export const getBetSizeLimit = (): Action => ({
		type: BETTING_LIMIT_ACTION_TYPE.getBetSizeLimit,
	});

	export const getBetSizeLimitSuccess = (payload: BettingLimit[]): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getBetSizeLimitSuccess,
		payload,
	});

	export const getBetSizeLimitFail = (payload: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getBetSizeLimitFail,
		payload,
	});

	export const getWageringLimit = (): Action => ({
		type: BETTING_LIMIT_ACTION_TYPE.getWageringLimit,
	});

	export const getWageringLimitSuccess = (payload: BettingLimit[]): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getWageringLimitSuccess,
		payload,
	});

	export const getWageringLimitFail = (payload: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getWageringLimitFail,
		payload,
	});

	export const getTimedWageringLimit = (): Action => ({
		type: BETTING_LIMIT_ACTION_TYPE.getTimedWageringLimit,
	});

	export const getTimedWageringLimitSuccess = (payload: BettingLimit[]): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getTimedWageringLimitSuccess,
		payload,
	});

	export const getTimedWageringLimitFail = (payload: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getTimedWageringLimitFail,
		payload,
	});

	export const getRemainingBetLimit = (): Action => ({
		type: BETTING_LIMIT_ACTION_TYPE.getRemainingBetLimit,
	});

	export const getRemainingBetLimitSuccess = (payload: BettingLimit[]): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getRemainingBetLimitSuccess,
		payload,
	});

	export const getRemainingBetLimitFail = (payload: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getRemainingBetLimitFail,
		payload,
	});

	export const getNetlossLimit = (): Action => ({
		type: BETTING_LIMIT_ACTION_TYPE.getNetlossLimit,
	});

	export const getNetlossLimitSuccess = (payload: BettingLimit[]): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getNetlossLimitSuccess,
		payload,
	});

	export const getNetlossLimitFail = (payload: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.getNetlossLimitFail,
		payload,
	});

	export const updateBetCountLimit = (payload: BettingLimitParams): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateBetCountLimit,
		payload,
	});

	export const updateBetCountLimitSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateBetCountLimitSuccess,
		payload,
	});

	export const updateBetCountLimitFail = (payload: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateBetCountLimitFail,
		payload,
	});

	export const updateBetSizeLimit = (payload: BettingLimitParams): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateBetSizeLimit,
		payload,
	});

	export const updateBetSizeLimitSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateBetSizeLimitSuccess,
		payload,
	});

	export const updateBetSizeLimitFail = (payload: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateBetSizeLimitFail,
		payload,
	});

	export const updateWageringLimit = (payload: WageringLimitParams): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateWageringLimit,
		payload,
	});

	export const updateWageringLimitSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateWageringLimitSuccess,
		payload,
	});

	export const updateWageringLimitFail = (payload: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateWageringLimitFail,
		payload,
	});

	export const updateTimedWageringLimit = (payload: TimedBettingLimitParams): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateTimedWageringLimit,
		payload,
	});

	export const updateTimedWageringLimitSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateTimedWageringLimitSuccess,
		payload,
	});

	export const updateTimedWageringLimitFail = (payload: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateTimedWageringLimitFail,
		payload,
	});

	export const updateNetlossLimit = (payload: TimedBettingLimitParams): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateNetlossLimit,
		payload,
	});

	export const updateNetlossLimitSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateNetlossLimitSuccess,
		payload,
	});

	export const updateNetlossLimitFail = (payload: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.updateNetlossLimitFail,
		payload,
	});

	export const deleteBetCountLimit = (): Action => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeBetCountLimit,
	});

	export const deleteBetCountLimitSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeBetCountLimitSuccess,
		payload,
	});

	export const deleteBetCountLimitFail = (error: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeBetCountLimitFail,
		payload: error,
	});

	export const deleteBetSizeLimit = (): Action => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeBetCountLimit,
	});

	export const deleteBetSizeLimitSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeBetCountLimitSuccess,
		payload,
	});

	export const deleteBetSizeLimitFail = (error: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeBetCountLimitFail,
		payload: error,
	});

	export const deleteWageringLimit = (): Action => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeWageringLimit,
	});

	export const deleteWageringLimitSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeWageringLimitSuccess,
		payload,
	});

	export const deleteWageringLimitFail = (error: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeWageringLimitFail,
		payload: error,
	});

	export const deleteTimedWageringLimit = (): Action => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeTimedWageringLimit,
	});

	export const deleteTimedWageringLimitSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeTimedWageringLimitSuccess,
		payload,
	});

	export const deleteTimedWageringLimitFail = (error: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeTimedWageringLimitFail,
		payload: error,
	});

	export const deleteTimedWageringLimitWithPayload = (payload: TimedBettingLimitParams): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeTimedWageringLimitWithPayload,
		payload,
	});

	export const deleteTimedWageringLimitWithPayloadSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeTimedWageringLimitWithPayloadSuccess,
		payload,
	});

	export const deleteTimedWageringLimitWithPayloadFail = (error: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeTimedWageringLimitWithPayloadFail,
		payload: error,
	});

	export const deleteNetlossLimit = (): Action => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeNetlossLimit,
	});

	export const deleteNetlossLimitSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeNetlossLimitSuccess,
		payload,
	});

	export const deleteNetlossLimitFail = (error: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeNetlossLimitFail,
		payload: error,
	});

	export const deleteNetlossLimitWithPayload = (payload: TimedBettingLimitParams): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeNetlossLimitWithPayload,
		payload,
	});

	export const deleteNetlossLimitWithPayloadSuccess = (payload: BettingLimit): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeNetlossLimitWithPayloadSuccess,
		payload,
	});

	export const deleteNetlossLimitWithPayloadFail = (error: AppError): ActionWithPayload => ({
		type: BETTING_LIMIT_ACTION_TYPE.removeNetlossLimitWithPayloadFail,
		payload: error,
	});

	export const reset = () => ({
		type: BETTING_LIMIT_ACTION_TYPE.reset,
	});
}
